import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvButtonModule } from 'projects/shared/nvps-libraries/design/nv-button/nv-button.module';
import { PassRatesComponent } from './pass-rates.component';
import { PassRatesSummaryData } from './pass-rates-summary-data.service';
import { PassRatesRoutingModule } from './pass-rates-routing.module';
import { PageBannerModule } from 'Src/ng2/shared/components/page-banner/page-banner.module';
import { NvDropdownBoxModule } from 'Src/nvps-libraries/design/nv-dropdown-box/nv-dropdown-box.module';
import { RollupTableModule } from 'Src/ng2/shared/components/rollup-list/rollup-table/rollup-table.module';
import { VizModule } from 'Src/ng2/school/mid-level-dashboard/viz/viz.module';
import { ExitViewModule } from 'Src/ng2/shared/components/exit-view/exit-view.component.module';
import { NvIconModule } from 'projects/shared/nvps-libraries/design/nv-icon/nv-icon.module';
import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { PassRatesService } from '../../../../shared/services/pass-rates/pass-rates.service';
import { NvNoteModule } from 'projects/shared/nvps-libraries/design/nv-note/nv-note.module';
import { NvDropdownPillModule } from 'projects/shared/nvps-libraries/design/nv-dropdown-pill/nv-dropdown-pill.module';
import { NvPillV4Module } from 'Src/nvps-libraries/design/nv-pill-v4/nv-pill-v4.module';

@NgModule({
  declarations: [PassRatesComponent],
  exports: [PassRatesComponent],
  imports: [
    CommonModule,
    ExitViewModule,
    NvIconModule,
    NvNoteModule,
    NvButtonModule,
    NvDropdownBoxModule,
    NvDropdownPillModule,
    NvTooltipModule,
    PageBannerModule,
    PassRatesRoutingModule,
    RollupTableModule,
    VizModule,
    NvPillV4Module,
  ],
  providers: [PassRatesSummaryData, PassRatesService],
})
export class PassRatesModule {}
